import React from 'react';
import PropTypes from 'prop-types';

import './SBOTDPlaceholder.scss';

/**
 * @group Personalization
 * Placeholder module for SBOTD injection
 */

const SBOTDPlaceholder = (props) => {
  const { opts } = props;
  return (
    <div id="sbotd" className="sbotdwidget" data-view={opts.options.view} />
  );
};

SBOTDPlaceholder.propTypes = {
  opts: PropTypes.shape({
    options: PropTypes.shape({
      view: PropTypes.string,
    })
  })
};
SBOTDPlaceholder.defaultProps = {
  opts: {
    options: {
      view: ''
    }
  }
};

export default SBOTDPlaceholder;
